import React from 'react';

const Pills = props => (
  <div className='pillSelct mb-3'>
    <ul className='pillSelct-pills'>
      {
        props.proformas.map(proforma => (
          <li className='pill pill-cyan pillSelct-pills-item' key={proforma.nroProforma}>
            {proforma.nroProforma}
            <button
              type='button'
              className='pillSelct-delete'
              onClick={() => props.unselectProforma({ proforma })}
            >
              <i className='icon ion-close pill-close' />
            </button>
          </li>
        ))
      }
    </ul>
  </div>
);

export default Pills;



// WEBPACK FOOTER //
// ./src/pages/modals/NuevaFichaVenta/Pills.js